/**
 * Environment-style credential assignment patterns:
 *
 * Detects credentials in environment variable style assignments:
 * - Left-hand side (LHS): Uppercase variable name containing intent words like
 *   TOKEN, SECRET, PASS, API_KEY, ACCESS, or AUTH
 * - Right-hand side (RHS): Long token-like string (32+ alphanumeric/dash/underscore
 *   or 40+ base64 characters)
 * - Excludes plain 24-character hex strings (MongoDB ObjectIds)
 *
 * Examples:
 * - API_KEY=sk1234567890abcdefghijklmnopqrstuv
 * - SECRET_TOKEN: eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...
 * - DATABASE_PASSWORD=my_super_secret_password_12345678
 */

export const envCredential =
  /\b[A-Z0-9_]*(TOKEN|SECRET|PASS|API_?KEY|ACCESS|AUTH)[A-Z0-9_]*\s*[:=]\s*["']?(?![A-Fa-f0-9]{24}\b)([A-Za-z0-9_-]{32,}|[A-Za-z0-9+/=]{40,})["']?/i;
